module.exports = __webpack_public_path__ + "static/media/Proposition_Commerciale_Standard_DRAFT.0bcfee2f.docx";